<template>
  <footer class="bg-[#F7F9FA]">
      <div class="container mx-auto flex flex-wrap justify-center items-start py-20">
          <div class="xl:ml-0 lg:ml-7 md:mr-10 lg:mr-14 xl:mr-24 md:w-max w-[80vw]">
              <img src="/img/screeno-footer.png" alt="">
              <p class="font-mules font-normal my-5">Streaming and Video <span class="block">platform</span></p>
              <img src="/img/ig-black.png" class="inline mr-4" alt="">
              <img src="/img/fb-black.png" class="inline" alt="">
          </div>
          <div class="lg:mr-14 xl:mr-24 md:w-max w-[80vw] md:mt-0 mt-10">
              <p class="font-monstand font-semibold text-lg mb-4">Contact info</p>
              <div class="flex items-center">
                  <img src="/img/location-blue.png" class="mr-3" alt="">
                  <p class="font-mules font-medium">Kec Puger , Kab Jember</p>
              </div>
              <div class="flex items-center my-4">
                  <img src="/img/call.png" class="mr-4" alt="">
                  <p class="font-mules font-medium">62881026233067</p>
              </div>
              <div class="flex items-center">
                  <img src="/img/message-blue.png" class="mr-3" alt="">
                  <p class="font-mules font-medium">Rajasatir@gmail.com</p>
              </div>
          </div>
          <div class="flex flex-col w-[80vw] md:w-[450px] lg:w-[400px] xl:w-[500px] mt-10 lg:mt-0">
              <p class="font-monstand font-semibold text-lg mb-4">Get in touch</p>
              <input type="text" placeholder="Your name" id="" class="py-3 px-4 border rounded-xl">
              <input type="email" placeholder="Your Email" id="" class="py-3 px-4 border rounded-xl my-5">
              <textarea name="" id="" cols="20" rows="5" class="border rounded-xl p-3 mb-5" placeholder="Your message"></textarea>
              <button class="font-monstand font-medium text-white bg-[#006AFF] py-2 px-10 rounded-full w-max">Send</button>
          </div>
      </div>

      <div class="bg-[#C9C9C9] border"></div>
      <p class="font-mules font-medium text-sm text-center py-5">©2022 Screeno Ltd, All rights reserved</p>
  </footer>
</template>

<script>
export default {

}
</script>